import { Card, Button } from "react-bootstrap";
import { API_BASE_URL } from "../../api/api";

export const SelectedProductsCards = ({
  selectedProducts,
  getProductDetails,
  getPrice,
  onIncrement,
  onDecrement,
  onRemove,
  formatPrice
}) => {
  return (
    <>
      {selectedProducts.map((item) => {
        const product = getProductDetails(item.productId);
        const image = product.images?.[product.mainImage || 0];
        const imageUrl = `${API_BASE_URL}/product/get/file/${image}`;
        const price = getPrice(product);
        const subtotal = (price * item.quantity).toFixed(2);

        return (
          <Card key={product.id} className="mb-2">
            <div
              className="d-flex align-items-center justify-content-between px-3"
              style={{ height: "120px" }}
            >
              {/* Foto */}
              <div
                style={{
                  width: "100px",
                  height: "100px",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <img
                  src={imageUrl}
                  alt={product.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "6px",
                  }}
                />
              </div>

              {/* Nombre y precio */}
              <div className="px-3 flex-grow-1">
                <div className="fw-bold">{product.title}</div>
                <div className="text-muted small">{product.shortDescription}</div>
                <div className="text-muted small">{formatPrice(price)}</div>
              </div>

              {/* Cantidad y botones */}
              <div className="d-flex align-items-center justify-content-center" style={{ minWidth: "160px" }}>
                <Button
                  size="sm"
                  variant="warning"
                  className="py-0 px-2"
                  onClick={() => onDecrement(item.productId)}
                >
                  −
                </Button>
                <span className="mx-2">{item.quantity}</span>
                <Button
                  size="sm"
                  variant="warning"
                  className="py-0 px-2"
                  onClick={() => onIncrement(item.productId)}
                >
                  +
                </Button>
                <Button
                  size="sm"
                  variant="danger"
                  className="py-0 px-2 ms-2"
                  onClick={() => onRemove(item.productId)}
                  title="Eliminar producto"
                >
                  <i className="fa fa-trash" />
                </Button>
              </div>

              {/* Subtotal */}
              <div className="fw-semibold text-end" style={{ minWidth: "100px" }}>
                {formatPrice(subtotal)}
              </div>
            </div>
          </Card>
        );
      })}
    </>
  );
};
